import { selectJBPSettingsCurrentFYear } from 'legacy/lut/features/partner360/jbpSettings'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { Dropdown } from 'core-components/library/dropdown'
import { BaseCrud, Static } from 'core-components/types'

import {
  fYearSelected,
  selectHasMarketYoyGrowthDirtyEdits,
  selectIsMarketYoyGrowthSaving,
  selectMarketYoyGrowthSelectedFYear,
} from '../../../../model'

export const FYearSelect = () => {
  const dispatch = useAppDispatch()
  const currentFYear = useSelector(selectJBPSettingsCurrentFYear)
  const selectedFYear = useSelector(selectMarketYoyGrowthSelectedFYear)
  const hasDirtyEdits = useSelector(selectHasMarketYoyGrowthDirtyEdits)
  const isSaving = useSelector(selectIsMarketYoyGrowthSaving)

  const source = useMemo(() => {
    if (!currentFYear) {
      return null
    }

    const crud = new BaseCrud({
      fetcher: new Static([
        { value: currentFYear, text: String(currentFYear) },
        { value: currentFYear - 1, text: String(currentFYear - 1) },
      ]),
      keyField: 'value',
    })

    crud.setPaging({ page: 0, pageSize: 10 })

    return crud
  }, [currentFYear])

  if (!source || !selectedFYear) {
    return null
  }

  return (
    <Dropdown
      source={source}
      caption="text"
      value={selectedFYear}
      disabled={hasDirtyEdits || isSaving}
      onChange={(value) => dispatch(fYearSelected(Number(value)))}
    />
  )
}

FYearSelect.displayName = 'FYearSelect'
